import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'app.legal.cxengage.pageTitle',
    defaultMessage: 'CxEngage Legal Disclaimer',
  },
  header: {
    id: 'app.legal.cxengage.header',
    defaultMessage: 'Legal Disclaimer',
  },
  lastUpdate: {
    id: 'app.legal.cxengage.lastUpdate',
    defaultMessage: 'Last updated: {lastUpdate}',
  },
  disclaimer: {
    id: 'app.legal.cxengage.disclaimer',
    defaultMessage:
      `Access to this site requires permission from Serenova, LLC in accordance with Purchased Services for Serenova Platforms, Serenova Products, and Certified Third-Party Products (&ldquo;Services&rdquo;). By using or accessing this site, you agree to the terms for Services located at {link}, that Services are purchased as a subscription providing you a right to access and use the Services during the applicable Subscription Term, additional Services may be added during the applicable Subscription Term under the applicable Order Form and can be prorated for the remainder of the Subscription Term in effect at the time the additional subscriptions are added, and any added Services will terminate on the same date as the pre-existing subscriptions. This site contains proprietary and confidential information and may also contain content and interaction with users from third-party sites subject to different terms with which you also must agree and comply.`,
  },
});
